import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const HowItWorksMenuPage = () => {
  const navigate = useNavigate();

  // Redirect to "Who We Are" by default when this page loads
  useEffect(() => {
    navigate('/who-we-are', { replace: true });
  }, [navigate]);

  return null;
};

export default HowItWorksMenuPage;
